module.exports = __webpack_public_path__ + "static/media/export.971cbd36.svg";